import request from '@/utils/request'

export function register(data) {
  return request({
    url: '/api/v1/teachers/register',
    method: 'post',
    data
  })
}

export function registerByMobile(data) {
  return request({
    url: '/api/v1/teachers/registerByMobile',
    method: 'post',
    data
  })
}

export function loginByUsername(username, password) {
  var formData = new FormData()

  formData.append('username', username)
  formData.append('password', password)
  formData.append('grant_type', 'password')
  return request({
    url: '/api/v1/systemManager/logon',
    // url: '/oauth/token',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: formData
  })
}

export function loginBySms(mobile, code) {
  var formData = new FormData()

  formData.append('mobile', mobile)
  formData.append('code', code)
  return request({
    url: '/api/v1/systemManager/loginTeacherSms',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: formData
  })
}

export function loginByMp(params) {
  return request({
    url: '/api/v2/user/vt/login',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params
  })
}

export function bindUser(params) {
  return request({
    url: '/api/v2/user/vt/bindUser',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params
  })
}

export function unBindUser(params) {
  return request({
    url: '/api/v2/user/unBindUser',
    method: 'get',
    params
  })
}

export function slideToGetSmsCode(data) {
  var formData = new FormData()

  formData.append('smsCodeType', data.smsCodeType)
  formData.append('mobile', data.mobile)
  formData.append('sig', data.sig)
  formData.append('sessionId', data.sessionId)
  formData.append('token', data.token)
  formData.append('scene', data.scene)
  return request({
    url: '/api/v1/systemManager/vt/slideToGetSmsCode',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: formData
  })
}

export function oauth(username, password) {
  const data = {
    username,
    password,
    grant_type: 'password'
  }
  return request({
    url: '/oauth/token',
    method: 'post',
    data
  })
}
export function logout() {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}
export function getUserInfo(params) {
  return request({
    url: '/api/v1/teachers/show',
    method: 'get',
    params
  })
}
export function checkTeacherStatus(params) {
  return request({
    url: '/api/v1/teachers/checkTeacherStatus',
    method: 'get',
    params
  })
}
export function updateTeacherStatus(params) {
  return request({
    url: '/api/v1/teachers/updateTeacherStatus',
    method: 'get',
    params
  })
}
export function getResetPasswordEmail(params) {
  return request({
    url: '/api/v1/teachers/sendResetPasswordEmail',
    method: 'get',
    params
  })
}
export function sendActivateCode(params) {
  return request({
    url: '/api/v1/teachers/sendActivateCode',
    method: 'get',
    params
  })
}
export function forgetPassword(data) {
  return request({
    url: '/api/v1/teachers/forgetPassword',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js